import React from "react";
import { useSelector } from "react-redux";
import { Box, Stack } from "@mui/material";
import { motion } from "framer-motion";

import ListTile from "./ticket_list_page_component/listTile";
import DateTile from "./ticket_list_page_component/dateTile";
import EmptyState from "./ticket_list_page_component/EmptyState";
import { groupByFormattedDate } from "../utils";
// import * as workpalJS from "@workpal-build/workpaljs"; //comment out this for future use

function TicketListPage({ print }) {
  // Redux as state management
  const state = useSelector((state) => {
    return state;
  });

  const grouped = groupByFormattedDate(state.ticket.history, "formattedCreatedDate");
  const sorted = Object.keys(grouped)
    .sort((a, b) => new Date(b) - new Date(a))
    .reduce((sortedAcc, key) => {
      sortedAcc[key] = grouped[key];
      return sortedAcc;
    }, {});

  return (
    <motion.div
      sx={{ height: "100vh" }}
      initial={{ x: "0%" }}
      animate={{ width: "100%" }}
      exit={{ x: -window.innerWidth, transition: { duration: 0.2 } }}
    >
      <Stack>
        {Object.keys(sorted).length > 0 && (
          <Box sx={{ paddingBottom: "100px" }}>
            {Object.keys(sorted).map((date, i) => {
              return (
                <div key={i}>
                  <DateTile date={grouped[date][0].createdDate} />
                  {grouped[date].map((eachItem) => {
                    return (
                      <ListTile
                        key={eachItem.id}
                        caseId={eachItem.id}
                        caseNumber={eachItem.caseNumber}
                        status={eachItem.status}
                        topic={eachItem.topic}
                        category={eachItem.category}
                        issue={eachItem.issue}
                        date={eachItem.formattedDate}
                      />
                    );
                  })}
                </div>
              );
            })}
          </Box>
        )}
        {!Object.keys(sorted).length && (
          <EmptyState
            message="If you have reported any IT issues in the past 12 months, it will appear
        here."
          />
        )}
      </Stack>
    </motion.div>
  );
}

export default TicketListPage;
